import { PopoverAnchor } from "components/ui/popover";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "components/ui/tooltip";
import { Icon } from "components/icon/Icon";
import { cn } from "utils";

interface KeywordFeedbackPopoverTriggerProps {
  keyword: string;
  isFlagged: boolean;
  tooltipText?: string;
  ariaText: string;
  onClick: () => void;
}

export const KeywordFeedbackPopoverTrigger = ({
  keyword,
  isFlagged,
  tooltipText,
  ariaText,
  onClick,
}: KeywordFeedbackPopoverTriggerProps) => (
  <TooltipProvider delayDuration={400}>
    <Tooltip>
      <PopoverAnchor asChild>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={onClick}
            aria-label={ariaText}
            data-testid={`feedback-flag-${keyword}`}
            className={cn(
              "flex items-center justify-center w-8 h-8 rounded-md transition-colors cursor-pointer shrink-0",
              isFlagged
                ? "text-amber-500 hover:text-amber-600"
                : "text-secondary-300 opacity-0 group-hover:opacity-100 hover:text-secondary-500 hover:bg-secondary-50",
            )}
          >
            <Icon
              name="thumbs-down"
              size="small"
              iconClassName={isFlagged ? "fill-current" : undefined}
            />
          </button>
        </TooltipTrigger>
      </PopoverAnchor>
      {tooltipText && (
        <TooltipContent side="right" className="text-xs">
          {tooltipText}
        </TooltipContent>
      )}
    </Tooltip>
  </TooltipProvider>
);
